export enum IconSizes {
    Micro = "micro",
    Tiny = "tiny",
    Mini = "mini",
    Small = "small",
    Smaller = "smaller",
    MiniCartEmpty = "minicart-empty",
}

export enum IconTypes {
    Search = "search",
    Profile = "profile",
    Close = "close",
    Like = "like",
    Bag = "bag",
    BagEmpty = "bag-empty",
    Heart = "heart",
    Trashcan = "trashcan",
    Bell = "bell",
    Clock = "clock",
    SoldoutX = "product-soldout-x",
    AvailableCheck = "product-available-check",
    ProductFilter = "product-filter",
    ProductSortBy = "product-sort-by",
    ChevronDown = "chevron-down",
}
